import React, { Fragment, useEffect, useState } from "react";
import CommonFrom from "../../../Common/Components/Form";
import { changepass } from "./Components/Services";
import Loading from "../../../Common/Components/Loading";
import { useDispatch } from "react-redux";

function Password(props) {
  const initialState = {
    loading: false,
  };
  const [state, setstate] = useState(initialState);
  const dispatch = useDispatch();
  let input = [
    {
      label: "رمزعبور قبلی",
      disabled: props.old ? true : false,
      size: "col-md-6",
      classNames: "mt-2",
      placeholder: "",
      name: "oldpassword",
      value: "",
      type: "password",
    },
    {
      label: "رمزعبور جدید",
      size: "col-md-6",
      classNames: "mt-2",
      placeholder: "",
      name: "newpassword",
      value: "",
      type: "password",
    },
  ];

  const Handler = data => {
    setstate({ loading: true });
    changepass(data).then(() => {
      setstate({
        loading: false,
      });
    });
  };

  return (
    <Fragment>
      {state.loading ? (
        <Loading count={1} col={12} height={200} />
      ) : (
        <CommonFrom
          form={input}
          loading={false}
          // header={props.isApp ? null : "تغیر رمز عبور"}
          header={"تغیر رمز عبور"}
          shadowClass={!props.isApp ? null : "shadow-none mt-4 appInputBox"}
          btnName="ثبت رمز جدید"
          submit={Handler}

        />
      )}
    </Fragment>
  );
}

export default Password;
